function IconCashOff({
  color = 'currentColor',
  size = 28,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6667 9H19.6667C20.1972 9 20.7059 9.21071 21.081 9.58579C21.456 9.96086 21.6667 10.4696 21.6667 11V17M19.6667 19H9.66675C9.13632 19 8.62761 18.7893 8.25253 18.4142C7.87746 18.0391 7.66675 17.5304 7.66675 17V11C7.66675 10.4696 7.87746 9.96086 8.25253 9.58579C8.62761 9.21071 9.13632 9 9.66675 9M13.2487 12.5901C12.8846 12.9675 12.6834 13.4729 12.6883 13.9973C12.6932 14.5217 12.9039 15.0232 13.275 15.3937C13.6461 15.7643 14.1479 15.9743 14.6723 15.9785C15.1967 15.9826 15.7017 15.7807 16.0787 15.4161M17.6667 9V7C17.6667 6.46957 17.456 5.96086 17.081 5.58579C16.7059 5.21071 16.1972 5 15.6667 5H9.66675M5.66675 5C5.13632 5 4.62761 5.21071 4.25253 5.58579C3.87746 5.96086 3.66675 6.46957 3.66675 7V13C3.66675 13.5304 3.87746 14.0391 4.25253 14.4142C4.62761 14.7893 5.13632 15 5.66675 15H7.66675M3.66675 3L21.6667 21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconCashOff.displayName = 'IconCashOff';

export default IconCashOff;
